import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronDownFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronDownFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m19 7.56-7 5.15-7-5.15v3.72l7 5.16 7-5.16V7.56Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ChevronDownFilled;